module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "contentshead"
  }, [_c('span', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm",
    attrs: {
      "id": "rfm1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction#fm1"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "rpt1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Part001#pt1"
    }
  }, [_vm._v("PRINCIPLE ONE: WATER IS A HUMAN RIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter001#ch1"
    }
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter001#ch1"
    }
  }, [_vm._v("The Case for the Right to Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter002#ch2"
    }
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter002#ch2"
    }
  }, [_vm._v("The Fight for the Right to Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter003#ch3"
    }
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter003#ch3"
    }
  }, [_vm._v("Implementing the Right to Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paying for Water for All")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "rpt2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Part002#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRINCIPLE TWO: WATER IS A COMMON HERITAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water — Commons or Commodity?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Targeting Public Water Services")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Loss of the Water Commons Devastates Communities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reclaiming the Water Commons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "rpt3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Part003#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRINCIPLE THREE: WATER HAS RIGHTS TOO")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Trouble with “Modern Water”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corporate Control of Farming Is Extinguishing Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Energy Demands Place an Unsustainable Burden on Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Putting Water at the Centre of Our Lives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "rpt4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part004#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRINCIPLE FOUR: WATER CAN TEACH US HOW TO LIVE TOGETHER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confronting the Tyranny of the One Percent")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1",
    attrs: {
      "id": "rch14"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter014#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter014#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Creating a Just Economy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1",
    attrs: {
      "id": "rch15"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter015#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter015#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protecting Land, Protecting Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1",
    attrs: {
      "id": "rch16"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter016#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16.")]), _c('span', {
    staticClass: "spacea"
  }), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter016#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Road Map to Conflict or to Peace?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1",
    attrs: {
      "id": "rbm1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm",
    attrs: {
      "id": "rbm2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Furtherreading#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm",
    attrs: {
      "id": "rbm3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Acknowledgements#bm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm",
    attrs: {
      "id": "rbm4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Index#bm4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 72
// module chunks = 0